import { Grid } from '@mui/material'
import { AppBox, AppDropZone, AppTextField, AppTypography } from 'components'
import { AppDatePicker } from 'components/base/date-picker/AppDatePicker'
import { AppTextArea } from 'components/base/text-area/AppTextArea'
import dayjs from 'dayjs'
import { FC } from 'react'
import { Control, Controller, UseFormSetValue } from 'react-hook-form'
import { NewsAlertPayload } from 'sdk'

interface Props {
  control: Control<NewsAlertPayload>
  setValue: UseFormSetValue<NewsAlertPayload>
}
export const AddEditNewsAlertForm: FC<Props> = ({ control, setValue }) => {
  return (
    <Grid container spacing={2} alignItems={'center'}>
      <Grid item xs={3}>
        <AppTypography fontSize={14} component={'span'}>
          Alert Start Date
          <AppTypography component={'span'} color={'error'}>
            *
          </AppTypography>
        </AppTypography>
      </Grid>
      <Grid item xs={9}>
        <AppDatePicker name="StartDate" required={true} control={control} defaultValue={dayjs(new Date())} />
      </Grid>
      <Grid item xs={3}>
        <AppTypography fontSize={14} component={'span'}>
          Article Date
          <AppTypography component={'span'} color={'error'}>
            *
          </AppTypography>
        </AppTypography>
      </Grid>
      <Grid item xs={9}>
        <AppDatePicker name="ArticleDate" required={true} control={control} defaultValue={dayjs(new Date())} />
      </Grid>
      <Grid item xs={3}>
        <AppTypography fontSize={14} component={'span'}>
          Title
          <AppTypography component={'span'} color={'error'}>
            *
          </AppTypography>
        </AppTypography>
      </Grid>
      <Grid item xs={9}>
        <AppTextField name="Title" required={true} control={control} />
      </Grid>
      <Grid item xs={3}>
        <AppTypography fontSize={14} component={'span'}>
          Acrticle URL
          <AppTypography component={'span'} color={'error'}>
            *
          </AppTypography>
        </AppTypography>
      </Grid>
      <Grid item xs={9}>
        <AppTextField name="ArticleUrl" required={true} control={control} />
      </Grid>
      <Grid item xs={3}>
        <AppTypography fontSize={14} component={'span'}>
          View All URL
          <AppTypography component={'span'} color={'error'}>
            *
          </AppTypography>
        </AppTypography>
      </Grid>
      <Grid item xs={9}>
        <AppTextField name="ViewAllUrl" required={true} control={control} />
      </Grid>
      <Grid item xs={3}>
        <AppTypography fontSize={14} component={'span'}>
          Description
          <AppTypography component={'span'} color={'error'}>
            *
          </AppTypography>
        </AppTypography>
      </Grid>
      <Grid item xs={9}>
        <AppTextArea name="Description" required={true} control={control} />
      </Grid>
      <Grid item xs={3}>
        <AppTypography fontSize={14} component={'span'}>
          Image
          <AppTypography component={'span'} color={'error'}>
            *
          </AppTypography>
        </AppTypography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          control={control}
          name="Image"
          rules={{ required: 'This field is required.' }}
          render={({ fieldState: { error }, field }) => {
            return (
              <AppBox>
                <AppDropZone
                  hideDragMessage={true}
                  onFileSelect={function (files: File[]): void {
                    setValue('Image', files[0])
                  }}
                  acceptedFileTypes={{ 'image/*': [] }}
                />
                {error?.message && <AppTypography color={'red'}>{error?.message}</AppTypography>}
                <AppTypography color={'grey.500'}>Image size should be 1000px X 600px</AppTypography>
              </AppBox>
            )
          }}
        />
      </Grid>
    </Grid>
  )
}
